// extracted by mini-css-extract-plugin
export var container = "testimonialsTwoColumn-module--container--1d44c";
export var dark = "testimonialsTwoColumn-module--dark--112d9";
export var light = "testimonialsTwoColumn-module--light--ca1d2";
export var testimonialsQuoteIcon = "testimonialsTwoColumn-module--testimonialsQuoteIcon--16526";
export var testimonialsQuoteTextWrapper = "testimonialsTwoColumn-module--testimonialsQuoteTextWrapper--f0e64";
export var testimonialsTwoColumn = "testimonialsTwoColumn-module--testimonialsTwoColumn--7e865";